import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_RO: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'Pentru bărbați',
  components_header_media_2: 'Pentru femei',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Antrenează-te mai inteligent, simte-te mai bine.',
  hero_button_text: 'Începeți acum',
  components_ressources_subheader_text: 'Ghiduri și sfaturi',
  components_ressources_span_text: 'Combină accentul pământesc al yoga, precizia controlată a Pilates și provocarea dinamică a antrenamentului de forță pentru a susține un stil de viață echilibrat și sănătos.',
  components_ressources_card_1_title: 'Sfaturi de yoga',
  components_ressources_card_1_text: 'Ghid rapid pentru un echilibru, o respirație și o fluiditate mai bune.',
  components_ressources_card_2_title: 'Sfaturi Pilates',
  components_ressources_card_2_text: 'Sfaturi simple pentru a-ți întări mușchii abdominali și a îmbunătăți controlul.',
  components_notes_and_google_title_1: 'Construiește forța',
  components_notes_and_google_title_2: 'Yoga Liniște',
  components_notes_and_google_title_3: 'Exerciții Pilates',
  media_content_section_multi_1_subheader_text: 'Videoclipuri de instruire',
  media_content_section_multi_2_subheader_text: 'Videoclipuri de yoga',
  media_content_section_multi_3_subheader_text: 'Videoclipuri Pilates',
  text_media_1: 'Bărbați',
  text_media_2: 'Femei',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Spate',
  page_media_content_menu_chest: 'Piept',
  page_media_content_menu_legs: 'Picioare',
  page_media_content_menu_shoulders: 'Umeri',
  page_media_content_menu_abdominals: 'Abdominali',
  components_text1_subheader_text: 'Dietă sănătoasă pentru viața ta activă',
  components_text1_span_text: 'Rețete sănătoase care îți susțin antrenamentul și îți îmbunătățesc starea de bine.',
  components_footer_text: 'Întărește-ți corpul, echilibrează-ți mintea și mișcă-te cu sens – locul tău pentru sală de sport, yoga și pilates.',
};